import React from 'react';
import classNames from 'classnames';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/*********************************************************************\n* © Copyright IBM Corp. 2024\n*********************************************************************/\n.checkbox__wrapper__checkbox__12-31-0 {\n    position: relative;\n  }\n.checkbox__icon__checkbox__12-31-0:before {\n      background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='var(--FontColorDefault, %23000000)'%3E %3Cpolygon fill-rule='evenodd' points='1 5 4.5 10 11 3 9.99 2 4.5 7 2.01 4'/%3E %3C/svg%3E\") center center no-repeat;\n    }\n.checkbox__icon__checkbox__12-31-0:focus-visible {\n      border-color: var(--ControlBorderColorFocusDefault, #007EFF);\n      -webkit-box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n              box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n      outline: none;\n    }\n.checkbox__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0:before {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      display: block;\n      height: 6px;\n      width: 6px;\n      border-radius: 1px;\n      -webkit-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%);\n      background: var(--FontColorDefault, #000000);\n    }\n.checkbox--focus__checkbox__12-31-0 {\n  border-color: var(--ControlBorderColorFocusDefault, #007EFF);\n  -webkit-box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n          box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n  outline: none;\n}\n.checkbox--dark__checkbox__12-31-0 > input + .checkbox__icon__checkbox__12-31-0:before {\n    background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='var(--FontColorWhite, %23FFFFFF)'%3E %3Cpolygon fill-rule='evenodd' points='1 5 4.5 10 11 3 9.99 2 4.5 7 2.01 4'/%3E %3C/svg%3E\") center center no-repeat;\n  }\n.checkbox--dark__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0 {\n    border-color: var(--Third, #007EFF);\n    background-color: var(--Third, #007EFF);\n  }\n.checkbox--dark__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0:before {\n      background: var(--FontColorWhite, #FFFFFF);\n    }\n.checkbox--error__checkbox__12-31-0 > input + .checkbox__icon__checkbox__12-31-0:before {\n    background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='var(--FontColorDefault, %23000000)'%3E %3Cpolygon fill-rule='evenodd' points='1 5 4.5 10 11 3 9.99 2 4.5 7 2.01 4'/%3E %3C/svg%3E\") center center no-repeat;\n  }\n.checkbox--error__checkbox__12-31-0 > input[type='checkbox'] + .checkbox__icon__checkbox__12-31-0 {\n      border-color: var(--Danger, #AE304A);\n      -webkit-box-shadow: 0 0 3px var(--Danger, #AE304A);\n              box-shadow: 0 0 3px var(--Danger, #AE304A);\n    }\n.checkbox--error__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0 {\n      background-color: var(--FontColorWhite, #FFFFFF);\n    }\n.checkbox--error__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0:before {\n        background: var(--FontColorDefault, #000000);\n      }\n.checkbox--error__checkbox__12-31-0 > input[type='checkbox']:checked + .checkbox__icon__checkbox__12-31-0 {\n      background-color: var(--FontColorWhite, #FFFFFF);\n    }\n.checkbox--error__checkbox__12-31-0.checkbox--dark__checkbox__12-31-0 > input + .checkbox__icon__checkbox__12-31-0:before {\n      background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='var(--FontColorWhite, %23FFFFFF)'%3E %3Cpolygon fill-rule='evenodd' points='1 5 4.5 10 11 3 9.99 2 4.5 7 2.01 4'/%3E %3C/svg%3E\") center center no-repeat;\n    }\n.checkbox--error__checkbox__12-31-0.checkbox--dark__checkbox__12-31-0 > input[type='checkbox'] + .checkbox__icon__checkbox__12-31-0 {\n        border-color: var(--Danger, #AE304A);\n        -webkit-box-shadow: 0 0 3px var(--Danger, #AE304A);\n                box-shadow: 0 0 3px var(--Danger, #AE304A);\n      }\n.checkbox--error__checkbox__12-31-0.checkbox--dark__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0 {\n        background-color: var(--Danger, #AE304A);\n      }\n.checkbox--error__checkbox__12-31-0.checkbox--dark__checkbox__12-31-0 > input[type='checkbox']:indeterminate + .checkbox__icon__checkbox__12-31-0:before {\n          background: var(--FontColorWhite, #FFFFFF);\n        }\n.checkbox--error__checkbox__12-31-0.checkbox--dark__checkbox__12-31-0 > input[type='checkbox']:checked + .checkbox__icon__checkbox__12-31-0 {\n        background-color: var(--Danger, #AE304A);\n      }\n.checkbox--single-line__checkbox__12-31-0 {\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.checkbox--single-line__checkbox__12-31-0 .checkbox__icon__checkbox__12-31-0 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n  }\n.checkbox--single-line__checkbox__12-31-0 .checkbox__content__checkbox__12-31-0 {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    display: block; /* for ellipsis */\n\n    overflow: hidden;\n\n    text-overflow: ellipsis;\n\n    white-space: nowrap;\n  }\n.checkbox-message__checkbox__12-31-0 {\n  display: block;\n  position: absolute;\n  bottom: calc(-1*(var(--SpaceS, 8px) + var(--FontSizeDefault, 13px)));\n  left: 0;\n  font-size: var(--FontSizeDefault, 13px);\n  line-height: var(--FontSizeTitleSubsection, 16px);\n}\n.checkbox-message--isError__checkbox__12-31-0 {\n    color: var(--Danger, #AE304A);\n  }\n";
var styles = {"checkbox__wrapper":"checkbox__wrapper__checkbox__12-31-0","checkbox__icon":"checkbox__icon__checkbox__12-31-0","checkbox":"checkbox__checkbox__12-31-0","checkbox--focus":"checkbox--focus__checkbox__12-31-0","checkbox--dark":"checkbox--dark__checkbox__12-31-0","checkbox--error":"checkbox--error__checkbox__12-31-0","checkbox--single-line":"checkbox--single-line__checkbox__12-31-0","checkbox__content":"checkbox__content__checkbox__12-31-0","checkbox-message":"checkbox-message__checkbox__12-31-0","checkbox-message--isError":"checkbox-message--isError__checkbox__12-31-0"};
styleInject(css);

var css$1 = "/*********************************************************************\n* © Copyright IBM Corp. 2024\n*********************************************************************/\n.control__icon__checkbox__12-31-0 {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  position: relative;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  border: 1px solid var(--ControlBorderColorDefault, rgba(64, 66, 73, 0.2));\n  border-radius: 2px;\n  width: var(--IconsSizeDefault, 16px);\n  height: var(--IconsSizeDefault, 16px);\n  background: var(--BackgroundDefault, #FFFFFF);\n}\n.control__icon__checkbox__12-31-0:before {\n    display: none;\n    content: '';\n    width: 14px;\n    height: 14px;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n.control__checkbox__12-31-0 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: var(--FontSizeDefault, 13px);\n}\n.control__checkbox__12-31-0 input {\n    display: none;\n  }\n.control__checkbox__12-31-0 input:disabled + .control__icon__checkbox__12-31-0 {\n    background-color: var(--Second200, #ECECED);\n  }\n.control__checkbox__12-31-0 input:focus + .control__icon__checkbox__12-31-0 {\n    -webkit-box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n            box-shadow: var(--ControlBoxShadowFocusDefault, 0 0 0 3px rgba(0, 126, 255, 0.2));\n    border-color: var(--ControlBorderColorFocusDefault, #007EFF);\n    outline: none;\n  }\n.control__checkbox__12-31-0 input:disabled:focus + .control__icon__checkbox__12-31-0 {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n  }\n.control__checkbox__12-31-0 input:checked + .control__icon__checkbox__12-31-0:before {\n    display: block;\n  }\n.control__checkbox__12-31-0 input ~ * {\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n.control__checkbox__12-31-0 input:disabled ~ * {\n    cursor: default;\n    opacity: var(--ControlDisabledOpacity, 0.5);\n  }\n.control__checkbox__12-31-0:hover input:not(:disabled) ~ .control__icon__checkbox__12-31-0 {\n    border-color: var(--ControlBorderColorHover, rgba(64, 66, 73, 0.4));\n  }\n.control__checkbox__12-31-0 > span:not(:empty) {\n    margin-left: var(--SpaceS, 8px);\n  }\n.control__checkbox__12-31-0 input:disabled ~ span {\n    opacity: var(--ControlDisabledOpacity, 0.5);\n  }\n.control--dark__checkbox__12-31-0 > .control__icon__checkbox__12-31-0 {\n    border-color: var(--Third, #007EFF);\n    border-top-color: var(--Third, #007EFF);\n    background-image: none;\n    background-color: var(--Third, #007EFF);\n  }\n.control--dark__checkbox__12-31-0 > input:not(:checked) + .control__icon__checkbox__12-31-0 {\n    border-color: var(--ControlBorderColorDefault, rgba(64, 66, 73, 0.2));\n    background-color: transparent;\n  }\n.control--dark__checkbox__12-31-0 > input:checked + .control__icon__checkbox__12-31-0 {\n    background-image: none;\n    background-color: var(--Third, #007EFF);\n  }\n.control--dark__checkbox__12-31-0:hover input:not(:disabled) ~ .control__icon__checkbox__12-31-0 {\n    border-color: var(--Third, #007EFF);\n  }\n";
var formControlStyles = {"control__icon":"control__icon__checkbox__12-31-0","control":"control__checkbox__12-31-0","control--dark":"control--dark__checkbox__12-31-0"};
styleInject(css$1);

/**
 * `Checkbox` is a cross-browser `<input>` with `type="checkbox"` stylized as
 * `<label>`, with borders and checkmark rendered manually to make sure
 * it looks the same in every browser.
 *
 * The actual `<input>` element itself is only rendered for form interaction
 * and is hidden by default. Because of that, `onClick` event
 * on the component would bubble up twice - once after click on the `<label>`
 * and then once again as browser-generated click on `<input>`. To prevent that,
 * `Checkbox` **does not bubble `onClick` event at all**. In order to react to checkbox
 * value change, use `onChange` handler. In most cases, it can be used in place
 * of `onClick` interchangably.
 */
var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);
  function Checkbox() {
    _classCallCheck(this, Checkbox);
    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }
  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.indeterminate) {
        this.setIndeterminate(true);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.indeterminate !== this.props.indeterminate) {
        this.setIndeterminate(this.props.indeterminate);
      }
    }
  }, {
    key: "setIndeterminate",
    value: function setIndeterminate(indeterminate) {
      if (this.input) {
        this.input.indeterminate = Boolean(indeterminate);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        label = _this$props.label,
        name = _this$props.name,
        value = _this$props.value,
        checked = _this$props.checked,
        disabled = _this$props.disabled,
        _onChange = _this$props.onChange,
        children = _this$props.children,
        isDark = _this$props.isDark,
        isError = _this$props.isError,
        message = _this$props.message,
        singleLine = _this$props.singleLine,
        required = _this$props.required,
        rest = _objectWithoutProperties(_this$props, ["label", "name", "value", "checked", "disabled", "onChange", "children", "isDark", "isError", "message", "singleLine", "required"]);
      return React.createElement("div", {
        className: styles.checkbox__wrapper
      }, React.createElement("label", {
        className: classNames(styles.checkbox, formControlStyles.control, isDark && [styles['checkbox--dark'], formControlStyles['control--dark']], isError && [styles['checkbox--error'], formControlStyles['control--error']], singleLine && styles['checkbox--single-line']),
        onClick: function onClick(event) {
          return event.stopPropagation();
        }
      }, React.createElement("input", Object.assign({
        type: "checkbox",
        name: name,
        ref: function ref(input) {
          if (input) {
            _this.input = input;
          }
        },
        onChange: function onChange(event) {
          if (_onChange) {
            _onChange({
              name: name,
              value: value,
              checked: event.target.checked
            }, event);
          }
          // clicking on indeterminate checkbox resets the indeterminate state on input
          // DOM element, we need to prevent that because we're in a fully controlled mode
          if (_this.props.indeterminate) {
            _this.setIndeterminate(true);
          }
        },
        checked: Boolean(checked),
        disabled: Boolean(disabled),
        required: Boolean(required),
        value: value
      }, rest)), React.createElement("i", {
        className: classNames(styles.checkbox__icon, formControlStyles.control__icon),
        tabIndex: 0,
        "aria-checked": Boolean(checked),
        role: "checkbox",
        onKeyDown: function onKeyDown(ev) {
          if (ev.keyCode === 32) {
            _this.input.click();
            ev.preventDefault();
          }
        }
      }), React.createElement("span", {
        className: styles.checkbox__content
      }, children || label)), React.createElement("span", {
        className: classNames(styles['checkbox-message'], isError && styles['checkbox-message--isError'])
      }, message));
    }
  }]);
  return Checkbox;
}(React.Component);

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/

export { Checkbox };
